import { Controller } from 'stimulus';

// Kebab menu for a template row. Toggles the floating menu, closes on
// outside click. Lives next to template_popover_controller — they
// coordinate by both targeting their own targets and each one closes the
// other on toggle via DOM queries.
export default class extends Controller {
  static targets = ['menu'];

  connect() {
    this.boundOutsideClick = this.handleOutsideClick.bind(this);
    document.addEventListener('click', this.boundOutsideClick, true);
  }

  disconnect() {
    document.removeEventListener('click', this.boundOutsideClick, true);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const opening = this.menuTarget.classList.contains('is-hidden');
    this.closeAll();
    if (opening) this.menuTarget.classList.remove('is-hidden');
  }

  handleOutsideClick(event) {
    if (this.menuTarget.classList.contains('is-hidden')) return;
    if (this.element.contains(event.target)) return;
    this.menuTarget.classList.add('is-hidden');
  }

  closeAll() {
    document.querySelectorAll('.ti-cpop').forEach((p) => p.classList.add('is-hidden'));
    document.querySelectorAll('.ti-rowmenu').forEach((m) => m.classList.add('is-hidden'));
  }
}
